import {
	PREMIUM_REVERSE_TRIAL_TASK,
	SITE_ADMINISTRATIONS_TASK,
} from '../../../../common/constants.tsx';
import type { Cards, TaskList } from '../../../../common/types.tsx';
import { messages } from './messages.tsx';

export const FeatureGate = {
	removeInitialProjectTemplateName: 'to-cleanup-remove-initial-project-template-name',
} as const;

export const Experiment = {
	scrumOnboarding: 'experiment.scrumOnboarding',
	jswReverseTrial: 'experiment.jswReverseTrial',
	rtQuickstartM1: 'experiment.rtQuickstartM1',
	tailoredOnboardingScrumAndSoftwareKanbanEligible:
		'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible',
} as const;

export const Experience = {
	fedRamp: 'experience.fedRamp',
} as const;

export const ProjectStyle = {
	teamManaged: 'projectStyle.teamManaged',
	companyManaged: 'projectStyle.companyManaged',
} as const;

export const UserRole = {
	siteAdmin: 'userRole.siteAdmin',
	jiraAdmin: 'userRole.jiraAdmin',
	admin: 'userRole.admin',
	projectAdmin: 'userRole.projectAdmin',
} as const;

export const Edition = {
	free: 'productEdition.free',
	standard: 'productEdition.standard',
	premium: 'productEdition.premium',
} as const;

export const Route = {
	softwareRoadmap: 'route.softwareRoadmap',
	softwareBacklog: 'route.softwareBacklog',
	softwareBoard: 'route.softwareBoard',
	softwareList: 'route.softwareList',
	projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
	issue: 'route.issue',
	softwareCalendar: 'route.softwareCalendar',
} as const;

export const Permissions = {
	notCanCreateProject: 'permissions.notCanCreateProject',
	hasPlanEditPermissions: 'permissions.hasPlanEditPermissions',
} as const;

export const Trait = {
	crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell',
} as const;

const DEFAULT_TASK_LIST = [PREMIUM_REVERSE_TRIAL_TASK];

export const TASK_LIST: TaskList = Object.freeze({
	root: {
		title: messages.rootTitle,
		items: DEFAULT_TASK_LIST,
	},
	reverseTrialRoot: {
		title: messages.reverseTrialRootTitle,
		items: DEFAULT_TASK_LIST,
	},
	[PREMIUM_REVERSE_TRIAL_TASK]: {
		title: messages.reverseTrialCardTitle,
		items: [SITE_ADMINISTRATIONS_TASK],
	},
});

const PLAN_ONBOARDING_TASKS: Cards = {
	[PREMIUM_REVERSE_TRIAL_TASK]: {
		position: {
			default: 900,
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiment.rtQuickstartM1, Edition.premium],
					value: false,
				},
				{
					condition: [Experiment.jswReverseTrial, Edition.premium],
					value: true,
				},
			],
		},
	},
	[SITE_ADMINISTRATIONS_TASK]: {
		position: { default: 125 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Edition.premium, UserRole.siteAdmin],
					value: true,
				},
				{
					condition: [Edition.standard, UserRole.siteAdmin],
					value: true,
				},
			],
		},
	},
};

// https://hello.atlassian.net/wiki/spaces/agile/pages/1093679513/Documentation+QS+Card+manager
export const TASK_VARIANTS: Cards = PLAN_ONBOARDING_TASKS;
